const HOSPITAL_CONTANTS = {
    LIST_HOSPITALS: 'v1/hospitals'
};

export default HOSPITAL_CONTANTS;
